import React from 'react'

const IFrame = () => {
  window.parent.postMessage('close-iframe', 'https://storeyview.com'); // '*' for any origin, restrict in production
  return (
    <div></div>
  )
}

export default IFrame